/*
 * Copyright (c) 2020.  Rikesh Lal Shrestha
 * All Rights Reserved
 */

import { httpAdminBase, httpClientBase, httpSystemBase } from './httpBaseUtil';

export function fetchSystemAPI(endpoint, params) {
  return httpSystemBase().get(`/${endpoint}`, { params });
}

export function storeSystemAPI(endpoint, data, isUpload = false) {
  return httpSystemBase(isUpload).post(`/${endpoint}`, data);
}

export function updateSystemAPI(endpoint, data, isUpload = false) {
  return httpSystemBase(isUpload).put(`/${endpoint}`, data);
}

export function destroySystemAPI(endpoint, id) {
  return httpSystemBase().delete(`/${endpoint}/${id}`);
}

export function fetchAdminAPI(endpoint, params) {
  return httpAdminBase().get(`/${endpoint}`, { params });
}

export function storeAdminAPI(endpoint, data, isUpload = false) {
  return httpAdminBase(isUpload).post(`/${endpoint}`, data);
}

export function updateAdminAPI(endpoint, data, isUpload = false) {
  return httpAdminBase(isUpload).put(`/${endpoint}`, data);
}

export function destroyAdminAPI(endpoint, id) {
  return httpAdminBase().delete(`/${endpoint}/${id}`);
}

export function deleteAdminAPI(endpoint, data) {
  return httpAdminBase().delete(`/${endpoint}`, { data });
}

export function downloadAdminAPI(endpoint, params) {
  return httpAdminBase(true).get(`/${endpoint}`, { params });
}

export function uploadAdminAPI(endpoint, data) {
  return httpAdminBase(true).put(`/${endpoint}`, data);
}

export function fetchClientAPI(endpoint, params) {
  return httpClientBase().get(`/${endpoint}`, { params });
}

export function storeClientAPI(endpoint, data, isUpload = false) {
  return httpClientBase(isUpload).post(`/${endpoint}`, data);
}

export function updateClientAPI(endpoint, data, isUpload = false) {
  return httpClientBase(isUpload).put(`/${endpoint}`, data);
}

export function destroyClientAPI(endpoint, id) {
  return httpClientBase().delete(`/${endpoint}/${id}`);
}

export function deleteClientAPI(endpoint, data) {
  return httpClientBase().delete(`/${endpoint}`, { data });
}

export function downloadClientAPI(endpoint, params) {
  return httpClientBase(true).get(`/${endpoint}`, { params });
}

export function uploadClientAPI(endpoint, data) {
  return httpClientBase(true).put(`/${endpoint}`, data);
}
